import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicabs() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Cab',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Mumbai cab services, ensuring a safe and hassle-free journey for every traveler. Our fleet includes well-maintained Sedan, SUV, and Luxury vehicles equipped with AC, spacious seating, and clean interiors for a smooth and enjoyable ride. Driven by professional, background-verified chauffeurs, each trip guarantees punctuality, courteous service, and complete safety. Whether it’s a one-way drop, airport transfer, or round trip, Sai Trupti Cabs ensures a seamless travel experience with transparent pricing and 24×7 customer support. From early morning airport drops to late-night returns, we make every Pune to Mumbai cab journey convenient, comfortable, and memorable.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



    "services": [
  {
    "name": "Pune to Mumbai Cab",
    "description": "Pune to Mumbai Cab offers reliable intercity travel between Pune and Mumbai with comfortable, well-maintained vehicles. Ideal for business trips, family travel, or airport transfers, this service ensures punctual pickups, skilled drivers, and transparent pricing for a smooth travel experience."
  },
  {
    "name": "Pune to Mumbai Taxi",
    "description": "Pune to Mumbai Taxi provides convenient and safe transportation for travelers commuting between Pune and Mumbai. With professional drivers, clean vehicles, and door-to-door service, this taxi option ensures a comfortable and hassle-free ride at competitive rates."
  },
  {
    "name": "Pune to Mumbai Car Rental",
    "description": "Pune to Mumbai Car Rental offers a wide range of cars to suit every traveler’s needs, from economy to luxury vehicles. Customers can choose self-drive or chauffeur-driven options, ensuring flexibility, comfort, and safety on the Pune-Mumbai route."
  },
  {
    "name": "Pune to Mumbai Cab Hire",
    "description": "Pune to Mumbai Cab Hire specializes in providing reliable and affordable cab hire services for intercity travel. Whether for business or leisure, customers can expect timely service, comfortable rides, and courteous chauffeurs ensuring a pleasant journey."
  },
  {
    "name": "Pune to Mumbai One Way Cab",
    "description": "Pune to Mumbai One Way Cab offers economical travel for customers who only need a single trip. With no return fare charged, this service is perfect for travelers seeking cost-effective and comfortable one-way transfers with on-time service."
  },
  {
    "name": "Pune to Mumbai Drop Taxi",
    "description": "Pune to Mumbai Drop Taxi focuses on one-way drop services, ensuring convenient and affordable intercity transfers. Drivers are experienced and familiar with the route, guaranteeing safe, timely, and comfortable travel to your Mumbai destination."
  },
  {
    "name": "Affordable Pune to Mumbai Cab",
    "description": "Affordable Pune to Mumbai Cab provides budget-friendly intercity transport without compromising on comfort or reliability. It’s ideal for frequent travelers, students, and families looking for dependable cab services at transparent and reasonable prices."
  },
  {
    "name": "Pune to Mumbai AC Cab",
    "description": "Pune to Mumbai AC Cab ensures a cool and comfortable ride with air-conditioned vehicles, perfect for Pune’s climate. The fleet includes sedans, SUVs, and premium cars, offering smooth and relaxing journeys with courteous chauffeurs."
  },
  {
    "name": "Pune to Mumbai Sedan Cab",
    "description": "Pune to Mumbai Sedan Cab provides mid-sized comfortable sedans ideal for small families or corporate travelers. These vehicles ensure a balance of comfort and affordability, featuring smooth rides, air conditioning, and ample luggage space."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Pune to Mumbai Innova Cab offers spacious and reliable Toyota Innovas, perfect for families and groups. With ample seating, air conditioning, and professional drivers, this service ensures a luxurious and safe intercity travel experience."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Pune to Mumbai Ertiga Cab features comfortable Maruti Ertiga vehicles suited for medium-sized groups. The service provides affordable rates, comfortable seating, and dependable drivers ensuring a smooth and pleasant journey."
  },
  {
    "name": "Pune to Mumbai Luxury Cab",
    "description": "Pune to Mumbai Luxury Cab caters to travelers seeking premium travel experiences. With high-end vehicles like BMW, Audi, and Mercedes, this service provides elegant interiors, professional chauffeurs, and top-tier comfort for executive or VIP travel."
  },
  {
    "name": "Pune to Mumbai Airport Transfer",
    "description": "Pune to Mumbai Airport Transfer offers dedicated cab services for passengers traveling to or from Mumbai Airport. Ensuring punctual pickups, real-time tracking, and reliable chauffeurs, it guarantees stress-free airport commutes day or night."
  },
  {
    "name": "Pune to Mumbai Outstation Cab",
    "description": "Pune to Mumbai Outstation Cab provides intercity travel services designed for comfortable long-distance trips. The fleet includes a variety of vehicles with professional drivers who ensure safe, smooth, and on-time travel between cities."
  },
  {
    "name": "Pune to Mumbai Online Cab Booking",
    "description": "Pune to Mumbai Online Cab Booking simplifies travel planning with easy online reservations, instant confirmations, and transparent pricing. Customers can select vehicle types, track rides, and manage bookings conveniently from their devices."
  },
  {
    "name": "Pune to Mumbai Cab Service near Me",
    "description": "Pune to Mumbai Cab Service near Me ensures quick and convenient access to nearby cabs for intercity travel. With a wide network of available drivers, it provides fast booking, comfortable rides, and reliable service from any location in Pune."
  }
],
"tableData": [
  ["Pune to Mumbai Cab", "Pune to Mumbai Taxi"],
  ["Pune to Mumbai Car Rental", "Pune to Mumbai Cab Hire"],
  ["Pune to Mumbai One Way Cab", "Pune to Mumbai Drop Taxi"],
  ["Affordable Pune to Mumbai Cab", "Pune to Mumbai AC Cab"],
  ["Pune to Mumbai Sedan Cab", "Pune to Mumbai Innova Cab"],
  ["Pune to Mumbai Ertiga Cab", "Pune to Mumbai Luxury Cab"],
  ["Pune to Mumbai Airport Transfer", "Pune to Mumbai Outstation Cab"],
  ["Pune to Mumbai Online Cab Booking", "Pune to Mumbai Cab Service near Me"]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Mumbai, perfect for business trips, airport transfers, and leisure travel."
  },
  {
    "WhyChooseheading": "Wide Range of Cab Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars based on your budget and travel preferences."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are skilled, polite, and well-versed with the Pune–Mumbai route, ensuring a safe and smooth journey every time."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy competitive rates with clear pricing—no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "On-Time Pickups and Drop-offs",
    "WhyChoosedescription": "We value your time and ensure punctual service, whether you're heading to Mumbai Airport, Navi Mumbai, or any other destination."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Cars",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and equipped for a comfortable long-distance journey."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance",
    "WhyChoosedescription": "Our customer support team is available round the clock to help you book, modify, or plan your Pune–Mumbai trip."
  },
  {
    "WhyChooseheading": "Easy Online and Offline Booking",
    "WhyChoosedescription": "Book your Pune to Mumbai cab effortlessly via call, WhatsApp, or our website, with instant confirmation and quick dispatch."
  }
]



























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mumbai cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Mumbai cab services for both one-way and round trips.',
  },
  {
    question: 'How can I book a Pune to Mumbai cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Mumbai cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for the Pune to Mumbai route?',
    answer: 'We offer a wide range of cabs including hatchbacks, sedans, SUVs, and tempo travellers to suit your travel needs and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai routes?',
    answer: 'Yes, all our drivers are professional, well-trained, and experienced in driving on the Pune–Mumbai Expressway to ensure a safe journey.',
  },
  {
    question: 'Can I book a Pune to Mumbai airport cab with Sai Trupti Cabs?',
    answer: 'Certainly. We provide dedicated Pune to Mumbai airport transfer services with on-time pickup and drop facilities.',
  },
  {
    question: 'Is the Pune to Mumbai cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Pune to Mumbai cab services to match your travel schedule and convenience.',
  },
  {
    question: 'What safety and hygiene protocols are followed during Pune to Mumbai cab trips?',
    answer: 'All our vehicles are sanitized before every trip, and our drivers maintain strict hygiene and follow all safety protocols.',
  },
  {
    question: 'What payment methods are accepted for Pune to Mumbai cab bookings?',
    answer: 'We accept multiple payment options including UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available during the Pune to Mumbai cab journey?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Mumbai journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Patil',
    feedback: 'I booked a Pune to Mumbai cab with Sai Trupti Cabs and had a very smooth experience. The driver was punctual and polite.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Mumbai airport transfer. Clean car and timely pickup!',
    rating: 5,
  },
];




















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-cab.jpg",
  "description": "Book Pune to Mumbai Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. 24/7 reliable service with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "16245"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune to Mumbai Cab | Fast & Affordable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. 24/7 reliable service with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Car Rental, Pune to Mumbai Cab Hire, Pune to Mumbai One Way Cab, Pune to Mumbai Drop Taxi, Affordable Pune to Mumbai Cab, Pune to Mumbai AC Cab, Pune to Mumbai Sedan Cab, Pune to Mumbai Innova Cab, Pune to Mumbai Ertiga Cab, Pune to Mumbai Luxury Cab, Pune to Mumbai Airport Transfer, Pune to Mumbai Outstation Cab, Pune to Mumbai Online Cab Booking, Pune to Mumbai Cab Service near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaicabs;